import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type AddonsAddonAccessUpdatePayload } from '@api/types.gen';
import { addonAccessUpdate } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { queryKeys } from '../query-keys';

export function useUpdateAddonAccess(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AddonsAddonAccessUpdatePayload) =>
      addonAccessUpdate({ path: { id }, body: payload }),
    // Invalidate the detail record too: the access tab seeds its form from it,
    // so without this the saved grants would read back as stale.
    ...withInvalidate(queryClient, [queryKeys.list(), queryKeys.detail(id)]),
    ...withError('Unable to update add-on access'),
  });
}
